import React from 'react';
//import PropTypes from 'prop-types';

import * as api from '_core/utils/api';
import { withLang } from '_core/hocs/withLang';
import { ModalOuter } from '_core/components/ModalOuter';
import { ModalInner } from '_core/components/ModalInner';
import { ProtectionOptions } from '_core/views/ProfileSecurityForm';

import { SECURITY_CHECK_TYPE } from 'basic/config';

export default withLang((props) => {
  const {
    getFirstLangString: l,

    securityInfo,
    setSecurityInfo
  } = props;

  const [protections, setProtections] = React.useState();

  React.useEffect(() => {
    api
      .getClientVisitorProtection()
      .then(setProtections)
      .catch((error) => {
        console.error(error);
        setProtections([]);
      });
  }, []);

  return (
    <ModalOuter open={true} closeIcon={false} maxWidth="sm">
      <ModalInner
        title={l('r.bezopasnost')}
        content={
          <ProtectionOptions
            type={SECURITY_CHECK_TYPE.FINOP}
            protections={protections}
            securityInfo={securityInfo}
            setSecurityInfo={setSecurityInfo}
          />
        }
      />
    </ModalOuter>
  );
});
